import { useEffect } from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { BREAKPOINTS } from "web/react/constants";
import { useWindowWidth } from "web/react/hooks/use-window-width/use-window-width";
import { closeSidebar } from "web/redux/ducks/feed-sidebar";
import { ReduxStoreState } from "web/redux/store";
import analytics from "web/script/analytics/analytics";

function extractSidebarState(state: ReduxStoreState): boolean {
    return state.feedSidebarReducer.open;
}

/**
 * Handles the sidebar state so you don't have to
 */
export function useSidebarHandler(): [boolean, () => void] {
    const isOpen = useReduxSelector(extractSidebarState);
    const dispatch = useDispatch();
    const windowWidth = useWindowWidth();

    function closeSidebarAction(): void {
        dispatch(closeSidebar());
        analytics.event("filter", "close");
    }

    useEffect(() => {
        if (isOpen && windowWidth >= BREAKPOINTS.Large) {
            dispatch(closeSidebar());
        }
        // We only want to run this hook when the width changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowWidth]);

    return [isOpen, closeSidebarAction];
}
